export { showApiError } from "./showApiError";
export type { ShowApiErrorOptions } from "./showApiError";
export {
  resolveFriendlyError,
  type FriendlyError,
  type ApiErrorLike,
} from "./errorCatalog";

import { resolveFriendlyError } from "./errorCatalog";
import { audienceOf, getCurrentUser } from "@/lib/auth/currentUser";

/**
 * Friendly one-line message for inline error banners (and anywhere a plain
 * string is needed instead of a toast). Routes the error through the SAME
 * catalog `showApiError` uses, so a banner shows "Reconnect required" instead
 * of a raw "(#190) OAuthException" / "[API] not approved to access REST...".
 *
 * Use this to replace raw `(err as Error)?.message || 'fallback'` patterns:
 *   setError(friendlyMessage(err, 'Failed to load customers'))
 *   {friendlyMessage(query.error, 'Could not load campaigns.')}
 *
 * Never throws; always returns a non-empty string.
 */
export function friendlyMessage(
  input: unknown,
  fallback?: string,
): string {
  return resolveFriendlyError(
    input as Parameters<typeof resolveFriendlyError>[0],
    fallback ? { description: fallback } : undefined,
    audienceOf(getCurrentUser()),
  ).description;
}
